import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
    useSortable
} from "@dnd-kit/sortable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CSS } from "@dnd-kit/utilities";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "../components/Loader";
import { useNavigate } from "react-router-dom";
import LogoutButton from "../components/common/LogoutButton";
import { logDOM } from "@testing-library/dom";


const SortableRow = ({ id, index, name }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        fontSize: "13px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #ddd",
        cursor: "grab"
    };

    return (
        <tr ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <td style={{ padding: "12px", fontWeight: 500 }}>{index + 1}</td>
            <td style={{ padding: "12px",textTransform:"uppercase" }}>{name}</td>
        </tr>
    );
};

const CategoryList = () => {
    const navigate = useNavigate()
    const [categories, setCategories] = useState([]);

    const fetchCategories = async () => {
        try {
            const token = localStorage.getItem("token");
            const { data } = await axios.get(
                `${process.env.REACT_APP_SERVER_API}/category/All`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return data || [];
        } catch (err) {
            return { categories: [] };
        }
    };

    const {
        data: category = {},
        isLoading: isCategoryLoading,
        refetch
    } = useQuery({
        queryKey: ["foodCategory"],
        queryFn: fetchCategories,
        enabled: !!localStorage.getItem("token"),
        staleTime: 1000 * 60 * 5,
    });

    useEffect(() => {
        if (category.categories) {
            setCategories(category.categories);
        }
    }, [category]);

useEffect(()=>{
    refetch()
},[])

    const sensors = useSensors(useSensor(PointerSensor));

    const handleDragEnd = (event) => {
        const { active, over } = event;


        if (active.id !== over.id) {
            const oldIndex = categories.findIndex((cat) => cat._id === active.id);
            const newIndex = categories.findIndex((cat) => cat._id === over.id);
            const newArray = arrayMove(categories, oldIndex, newIndex);
            setCategories(newArray);
        }
    };

    const handleReorderSave = async () => {
        try {
            const token = localStorage.getItem("token");

         
            const reorderedData = categories.map((cat, index) => ({
                id: cat._id,
                order: index + 1,
            }));

            await axios.patch(
                `${process.env.REACT_APP_SERVER_API}/category/reorder`,
                { categories: reorderedData },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success("Category order saved successfully!", {
                autoClose: 1000
            });
        } catch (err) {
            alert("Something went wrong while saving.");
        }
    };

    if (isCategoryLoading) {
        return <Loader />
    }

    return (
        <div style={{ maxWidth: "650px", margin: "0 auto", padding: "20px", backgroundColor: "#F6F9F9", fontFamily: "MonSemiBold" }}>
            <ToastContainer/>
            <LogoutButton/>
            <button
                style={{ ...styles.button, ...styles.backbuttonBtn }}
                onClick={() => navigate("/admin")}
            >
                <i className="ri-arrow-left-line"></i> Back
            </button>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h3 style={{ fontFamily: "MonBold", marginBottom: "6px", fontSize: "25px" }}>Reorder Categories</h3>
                <p style={{ fontFamily: "MonMedium", color: "#555", fontSize: "14px" }}>
                    Drag and drop the rows to reorder the categories
                </p>
            </div>

            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                <SortableContext
                    items={categories.map((cat) => cat._id)}
                    strategy={verticalListSortingStrategy}
                >
                    <table style={{ width: "80%", margin: "0 auto", borderCollapse: "collapse", boxShadow: "0 0 10px rgba(0,0,0,0.05)" }}>
                        <thead style={{ backgroundColor: "#f7f7f7" }}>
                            <tr>
                                <th style={{ textAlign: "left", padding: "12px", borderBottom: "1px solid #ddd" }}>#</th>
                                <th style={{ textAlign: "left", padding: "12px", borderBottom: "1px solid #ddd" }}>Category Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((cat, idx) => (
                                <SortableRow key={cat._id} id={cat._id} index={idx} name={cat.name} />
                            ))}
                        </tbody>
                    </table>
                </SortableContext>
            </DndContext>
            <div style={{ textAlign: "center" }}>

                <button onClick={handleReorderSave} style={{ ...styles.button, marginTop: "25px" }}>Reorder</button>
            </div>
        </div>
    );
};

const styles = {
    button: {
        fontFamily: "MonMedium",
        background: "#003366",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "8px 12px",
        cursor: "pointer",
    },
}
export default CategoryList;